import { undo as undo_1 } from './undo.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

const undo: RibbonButton = {
    key: 'undo',
    title: () => loc(undo_1),
    imageSrc: require('../svg/undo.svg'),
    shortcut: 'ctrl+Z',
    buttonState: formatState =>
        formatState.canUndo ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: plugin => plugin.getEditor().undo(),
};

export default undo;
